import { render, staticRenderFns } from "./Bus.vue?vue&type=template&id=cbd5b6a0"
import script from "./Bus.vue?vue&type=script&lang=js"
export * from "./Bus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports